import "slick-carousel";
import $ from "jquery";

const postCarouselSlick = () => {
  const init = () => {
    slider();
  };

  const slider = () => {
    const slickClass = ".post-carousel__slickjs";
    const sliders = $(slickClass);

    if (sliders.length === 0) return;

    sliders.each(function(index, slider) {
      const $slider = $(slider);
      const navContainer = $slider.closest('.post-carousel').find('.mi-image-slider-navigation');
      const dotsContainer = $slider.closest('.post-carousel').find('.mi-image-slider-dots');

      $slider.slick({
        dots: true,
        arrows: true,
        appendDots: dotsContainer,
        infinite: true,
        slidesToShow: 1,
        fade: true,
        nextArrow: navContainer.find('.mi-image-slider-button-next'),
        prevArrow: navContainer.find('.mi-image-slider-button-prev'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  };

  init();
};

try {
  postCarouselSlick();
} catch (e) {
  console.error("Slider: ", e);
}